<div class="field row" *ngIf="value != null">
  <label class="field-label" for="projected-mileage" translate="projectedMileageLabel"></label>
  <span class="field-data" id="projected-mileage" [ngClass]="{mileage: alertExists}" 
    [textContent]="value | localeNumber"></span>
</div>
